<style src="./ListItems.scss" lang="scss"></style>
<template>
  <tbody class="tbody" cellspacing="10">
    <template
      v-for="(item, itemIdx) in list">
      <tr
        :key="itemIdx"
        class="list-items"
        :class="{ 'notquoted': !item.quoted.isQuoted }">
        <td scope="row" class="item id">
          <span class="lot">{{ item.itemInfo && item.itemInfo.lot || '' }}</span>
          <span
            class="number"
            :class="{
              'number__notassociated': !item.associated.isAssociated,
              'number__notquoted': item.associated.isAssociated && !item.quoted.isQuoted
            }">
            {{ item.itemInfo && item.itemInfo.number }}
          </span>
        </td>

        <td class="item quotesmap" @click="showDetails(item.itemId, itemIdx)">
          <span class="badge avaliable">{{ item.quotationMap.avaliableQuotation }}</span>
          <span class="badge waiting">{{ item.quotationMap.waitingResponseQuotation }}</span>
          <span class="badge noquote">{{ item.quotationMap.rejectedQuotation }}</span>
        </td>

        <td class="item strict">
          <span
            v-if="item.itemInfo && item.itemInfo.strictToME"
            class="strict-to-me"
            title="Restrito para Micro Empresa">
            ME
          </span>
        </td>
        <td class="item guaranted" title="Item com garantia de preço">
          <icon-star v-if="item.quoted && item.quoted.isPriceGuaranted" />
        </td>

        <td class="item description" :title="item.itemInfo && item.itemInfo.description">
          <span class="info description">{{ item.itemInfo && item.itemInfo.description }}</span>
        </td>

        <td class="item quantity field">
          <div class="colfield" :title="item.itemInfo.unity">
            <span class="value">{{ item.itemInfo && item.itemInfo.unity }}</span>
          </div>
        </td>

        <td
          class="item quantity field"
          :title="`A quantidade desse item é: ${item.itemInfo.quantity} ${item.itemInfo.unity} com fator de ${item.itemInfo.factor}`">
          <div class="colfield right" >
            <span class="value">{{ item.itemInfo && item.itemInfo.quantity | DecimalNumber }}</span>
          </div>
          <div class="colfield right">
            <span class="value">x{{ item.itemInfo && item.itemInfo.factor | DecimalNumber}}</span>
          </div>
        </td>

        <!-- *********** COST ********* -->
        <td v-if="!item.associated.isAssociated" colspan="3" class="cell__notassociated">NÃO ASSOCIADO</td>

        <!-- QUOTED -->
        <template v-if="item.quoted.isQuoted">
          <td
            :title="item.quoted.lab"
            class="colfield lab"
            @click="chooseQuotations(item, itemIdx)">
            <span class="value">{{ item.quoted.lab }}</span>
          </td>
          <td
            :title="item.quoted.price | CurrencyBR('', decimalPrecision)"
            class="colfield unit">
            <span class="value">{{ item.quoted.price | CurrencyBR('', decimalPrecision) }}</span>
          </td>
          <td
            :title="item.quoted.total | CurrencyBR('', decimalPrecision)"
            class="colfield total separator">
            <span class="value">{{ item.quoted.priceTotal | CurrencyBR }}</span>
          </td>
        </template>

        <!-- ASSOCIATED -->
        <template v-if="!item.quoted.isQuoted && item.associated.isAssociated">
          <td
            :title="item.associated.lab"
            class="colfield lab"
            @click="chooseQuotations(item, itemIdx)">
            <span class="value">{{ item.associated.lab }}</span>
          </td>
          <td
            :title="item.quoted.price | CurrencyBR('', decimalPrecision)"
            class="colfield unit">
            <span class="value">{{ item.associated.price | CurrencyBR('', decimalPrecision) }}</span>
          </td>
          <td
            :title="item.quoted.total | CurrencyBR('', decimalPrecision)"
            class="colfield total separator">
            <span class="value">{{ item.associated.priceTotal | CurrencyBR }}</span>
          </td>
        </template>

        <!-- *********** CMED PRICE ********* -->
        <td v-if="!item.quoted.isQuoted" colspan="4" class="cell__notassociated">NÃO ESCOLHIDO</td>
        <template v-if="item.quoted.isQuoted">
          <td
            :title="item.quoted.cmedLab"
            class="colfield lab">
            <span class="value">{{ item.quoted.cmedLab }}</span>
          </td>
          <td
            :title="item.quoted.cmedPrice | CurrencyBR('', decimalPrecision)"
            class="colfield unit">
            <span class="value">{{ item.quoted.cmedPrice | CurrencyBR('', decimalPrecision) }}</span>
          </td>
          <td
            :title="item.quoted.total | CurrencyBR('', decimalPrecision)"
            class="colfield total">
            <span class="value">{{ item.quoted.cmedTotalPrice | CurrencyBR }}</span>
          </td>
          <td class="colfield perc separator">
            <span class="value">{{ item.quoted.cmedPerc | DecimalNumber('') }}</span>
          </td>
        </template>

        <!-- *********** ESTIMATED ********* -->
        <td
          :title="item.itemInfo.estimatedPrice | CurrencyBR('', decimalPrecision)"
          class="colfield unit">
          <span class="value">{{ item.itemInfo.estimatedPrice | CurrencyBR('', decimalPrecision) }}</span>
        </td>
        <td
          :title="item.itemInfo.estimatedTotal | CurrencyBR('', decimalPrecision)"
          class="colfield total">
          <span class="value">{{ item.itemInfo.estimatedTotalPrice | CurrencyBR }}</span>
        </td>
        <td class="colfield perc separator">
          <span class="value">{{ item.itemInfo.estimatedPerc | DecimalNumber('') }}</span>
        </td>

        <!-- *********** SALE ********* -->
        <td v-if="!item.quoted.haveProposal" colspan="3" class="cell__notassociated">
          <div class="noquote-container">
            <span class="no-quote">NÃO COTADO</span>
            <button
              v-if="item.quoted.price"
              type="button"
              class="doquote btn-small-ghost"
              @click="doQuoteAgain(item)">
              COTAR
            </button>
          </div>
        </td>

        <template
          v-if="item.quoted.haveProposal">
          <td
            :title="item.quoted.proposalPrice | CurrencyBR('', decimalPrecision)"
            :class="{ 'highmax': item.quoted.proposalIsHigherThanMaxprice }"
            class="colfield unit">
            <input
              @keydown.enter="proposalLostFocus(item)"
              @keydown.esc="escapeProposalEdition(item)"
              @keyup="key => proposalRefreshTotalPerc(key, item)"
              @focus="proposalSetFocus(item)"
              @blur="proposalLostFocus(item)"
              class="textbox inputprice"
              v-model="item.quoted.proposalPrice">
          </td>
          <td
            :title="item.quoted.proposalTotal | CurrencyBR('', decimalPrecision)"
            class="colfield total">
            <span class="value">{{ item.quoted.proposalTotalPrice | CurrencyBR('0,00') }}</span>
          </td>
          <td class="colfield perc separator">
            <input
              @keydown.enter="proposalLostFocus(item)"
              @keydown.esc="escapeProposalEdition(item)"
              @keyup="key => proposalRefreshTotalPrice(key, item)"
              @focus="proposalSetFocus(item)"
              @blur="proposalLostFocus(item)"
              class="textbox inputperc"
              v-model="item.quoted.proposalPerc">
          </td>
        </template>

        <!-- *********** MINIMUM ********* -->
        <td v-if="!item.quoted.haveMinimum" colspan="3" class="cell__notassociated">
          <span class="no-quote">NÃO COTADO</span>
        </td>
        <template v-if="item.quoted.haveMinimum">
          <td
            :title="item.quoted.minimumPrice | CurrencyBR('', decimalPrecision)"
            :class="{ 'highmax': item.quoted.minimumIsHigherThanMaxprice }"
            class="colfield unit">
            <input
              @keydown.enter="minimumLostFocus(item)"
              @keydown.esc="escapeMinimumEdition(item)"
              @keyup="key => minimumRefreshTotalPerc(key, item)"
              @focus="minimumSetFocus(item)"
              @blur="minimumLostFocus(item)"
              class="textbox inputprice"
              v-model="item.quoted.minimumPrice">
          </td>
          <td
            :title="item.quoted.minimumTotal | CurrencyBR('', decimalPrecision)"
            class="colfield total">
            <span class="value">{{ item.quoted.minimumTotalPrice | CurrencyBR('0,00') }}</span>
          </td>
          <td class="colfield perc separator">
            <input
              @keydown.enter="minimumLostFocus(item)"
              @keydown.esc="escapeMinimumEdition(item)"
              @keyup="key => minimumRefreshTotalPrice(key, item)"
              @focus="minimumSetFocus(item)"
              @blur="minimumLostFocus(item)"
              class="textbox inputperc"
              v-model="item.quoted.minimumPerc">
          </td>
        </template>

        <!-- DYNAMIC COLUMNS -->
        <!-- <td
          colspan="3"
          class="cell__notassociated"
          v-for="(dynamicColumn, dynamicColumnIdx) in item.dynamicColumns"
          :key="dynamicColumnIdx">
          <span class="no-quote">NÃO COTADO</span>
        </td> -->
        <!-- <template v-if="item.haveDynamicColumns"> -->
          <!-- <td
            :title="item.quoted.minimumPrice | CurrencyBR('', decimalPrecision)"
            :class="{ 'highmax': item.quoted.minimumIsHigherThanMaxprice }"
            class="colfield unit"> -->
          <td
            class="colfield"
            :class="columnHeader.columnType"
            v-for="(columnHeader, columnHeaderIdx) in dynamicColumnsHeader"
            :key="columnHeaderIdx">
            <input
              v-if="columnHeader.columnType === 'lab'"
              @keydown.enter="dynamicLostFocus(columnHeader, item)"
              @keydown.esc="escapeDynamicEdition(columnHeader, item)"
              @focus="dynamicSetFocus(columnHeader, item)"
              @blur="dynamicLostFocus(columnHeader, item)"
              class="textbox inputprice"
              v-model="item.dynamicColumns[columnHeader.columnId].value">
            <input
              v-if="columnHeader.columnType === 'unit'"
              @keydown.enter="dynamicLostFocus(columnHeader, item)"
              @keydown.esc="escapeDynamicEdition(columnHeader, item)"
              @keyup="key => dynamicUnitEntered(key, columnHeader, item)"
              @focus="dynamicSetFocus(columnHeader, item)"
              @blur="dynamicLostFocus(columnHeader, item)"
              class="textbox inputprice"
              v-model="item.dynamicColumns[columnHeader.columnId].value">
            <span
              v-if="columnHeader.columnType === 'total'"
              class="value">
              {{ item.dynamicColumns[columnHeader.columnId].value | TotalBR('0,00') }}
            </span>
            <input
              v-if="columnHeader.columnType === 'perc'"
              @keydown.enter="dynamicLostFocus(columnHeader, item)"
              @keydown.esc="escapeDynamicEdition(columnHeader, item)"
              @blur="dynamicLostFocus(columnHeader, item)"
              @keyup="key => dynamicPercEntered(key, columnHeader, item)"
              @focus="dynamicSetFocus(columnHeader, item)"
              class="textbox inputprice"
              v-model="item.dynamicColumns[columnHeader.columnId].value">
          </td>
          <!--<td class="colfield perc separator">
            <input
              @keydown.enter="minimumLostFocus(item)"
              @keydown.esc="escapeMinimumEdition(item)"
              @keyup="key => minimumRefreshTotalPrice(key, item)"
              @focus="minimumSetFocus(item)"
              @blur="minimumLostFocus(item)"
              class="textbox inputperc"
              v-model="item.quoted.minimumPerc"> -->
          <!-- </td> -->
        <!-- </template> -->
      </tr>

      <tr
        :key="`${itemIdx}Details`">
        <td colspan="22">
          <row-details
            v-if="showItemId === item.itemId"
            :info="item"
            @edit-association-item="editAssociationItem"
            @go-to-next-register="goToTheNext"
            @open-history="openHistoryOfItemPanel" />
        </td>
      </tr>
    </template>

    <right-side-panel
      ref="rspEditCost"
      title="Editar Custo"
      width="600px"
      :outside-close="false">
      <associate-item
        v-if="!!editAssociation.info"
        :info="editAssociation.info"
        @finish-edition="finishAssociationItem" />
    </right-side-panel>
    <right-side-panel
      ref="rspHistoryItem"
      title="Histórico do Item"
      width="1024px"
      :outside-close="false">
      <rsp-history-item
        v-if="!!editHistoryItem.info"
        :info="editHistoryItem.info"
        @finish-edition="finishHistoryItem" />
    </right-side-panel>
  </tbody>
</template>

<script>
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'
import { IconLockGliph, IconStar } from '@/components/primitives/icons'
import DefineLowestMaxPrice from '@/brain/item-pricing/define-lowest-max-price'
import RowDetails from '../row-details/RowDetails'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import AssociateItem from '../associate-item/AssociateItem'
import RspHistoryItem from '../rsp-history-item/RspHistoryItem'

export default {
  name: 'ListItems',
  components: {
    IconLockGliph,
    IconStar,
    RowDetails,
    RightSidePanel,
    AssociateItem,
    RspHistoryItem
  },
  props: {
    proposalMargin: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: null
    },
    columnContraction: {
      costLab: false,
      costUnit: false,
      costTotal: false,
      maxLab: false,
      maxUnit: false,
      maxTotal: false,
      estimatedLab: false,
      estimatedUnit: false,
      estimatedTotal: false,
      proposalUnit: false,
      proposalTotal: false,
      minimumUnit: false,
      minimumTotal: false,
      rankingDistributor: false,
      rankingLab: false,
      rankingUnit: false,
      rankingTotal: false
    }
  },
  data: () => ({
    showItemId: null,
    selectedItemIdx: null,
    proposal: {
      form: {
        originalPrice: null,
        originalTotalPrice: null,
        originalPerc: null
      }
    },
    minimum: {
      form: {
        originalPrice: null,
        originalTotalPrice: null,
        originalPerc: null
      }
    },
    dynamicColumn: {
      form: {
        columnId: null,
        originalValue: null
      }
    },
    list: [],
    editAssociation: {
      info: null
    },
    editHistoryItem: {
      info: null
    }
  }),
  computed: {
    decimalPrecision () { return this.$store.getters['ItemPricing/DECIMAL_PRECISION'] },
    dynamicColumnsHeader () {
      return this.$store.getters['ItemPricing/GET_DYNAMIC_COLUMNS']
    }
  },
  filters: {
    CurrencyBR,
    DecimalNumber,
    TotalBR (v, notNumber = '', minimumFractionDigits = 2) {
      let pValue = 0
      if (!isNaN(v)) {
        pValue = v
      } else {
        pValue = v && Number(v.toString().replace(/\./g, '').replace(',', '.'))
        if (isNaN(pValue)) {
          return notNumber
        }
      }
      const formatter = Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits })
      const n = formatter.format(Number(pValue).toFixed(minimumFractionDigits))
      if (n === 'NaN') {
        return notNumber
      }
      return n
    }
  },
  watch: {
    value: {
      handler () {
        const list = this.value.map(i => {
          let dynamicColumns = {}
          for (const dC in i.dynamicColumns) {
            let value = ''
            if (!isNaN(i.dynamicColumns[dC].value)) {
              value = DecimalNumber(i.dynamicColumns[dC].value, this.decimalPrecision, this.decimalPrecision)
            } else {
              value = i.dynamicColumns[dC].value
            }
            dynamicColumns[dC] = {
              ...i.dynamicColumns[dC],
              value
            }
          }
          return {
            ...i,
            quoted: {
              ...i.quoted,
              proposalPrice: DecimalNumber(i.quoted.proposalPrice, this.decimalPrecision, this.decimalPrecision),
              minimumPrice: i.quoted.minimumPrice && i.quoted.minimumPrice.toString().replace('.', ',')
            },
            dynamicColumns
          }
        })

        this.list = list
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    showDetails (itemId, itemIdx) {
      this.showItemId = this.showItemId === null || this.showItemId !== itemId ? itemId : null
      this.selectedItemIdx = itemIdx
    },
    goToTheNext () {
      if (this.list.length > (this.selectedItemIdx + 1)) {
        const itemId = this.list[this.selectedItemIdx + 1].itemId
        this.showItemId = itemId
      }
    },
    chooseQuotations (pItem, itemIdx) {
      this.$emit('edit-cost', {
        item: pItem,
        itemIdx: itemIdx
      })
    },
    proposalSetFocus (item) {
      this.proposal.form.originalPrice = item.quoted.proposalPrice
      this.proposal.form.originalTotalPrice = item.quoted.proposalTotalPrice
      this.proposal.form.originalPerc = item.quoted.proposalPerc
    },
    async proposalLostFocus (item) {
      let haveProposal = true
      let haveMinimum = true
      if (!item.quoted.proposalPrice) {
        haveProposal = false
        haveMinimum = false
      } else {
        haveProposal = item.quoted.proposalPrice &&
          item.quoted.proposalPrice.toString().trim().length > 0 &&
          this.convertCurrencyToNumber(item.quoted.proposalPrice) > 0
      }
      const newProposalInfo = {
        haveProposal,
        haveMinimum,
        proposalPrice: haveProposal ? this.convertCurrencyToNumber(item.quoted.proposalPrice) : '',
        proposalTotalPrice: haveProposal ? item.quoted.proposalTotalPrice : '',
        proposalPerc: haveProposal ? item.quoted.proposalPerc : ''
      }

      const payload = {
        quote: item.itemId,
        proposalPrice: newProposalInfo.proposalPrice,
        notQuote: !haveProposal
      }

      await this.$store.dispatch('ItemPricing/SAVE_SALE_MINIMUM', payload)
      this.$store.commit('ItemPricing/SET_ITEM', {
        itemId: item.itemId,
        info: {
          quoted: {
            ...item.quoted,
            ...newProposalInfo
          }
        }
      })
    },
    proposalRefreshTotalPerc (key, item) {
      if (key.keyCode === 9 || key.keyCode === 16) {
        return
      }

      const quantity = (item.itemInfo && item.itemInfo.quantity) || 0
      const factor = (item.itemInfo && item.itemInfo.factor) || 0

      const quotedPrice = item.quoted.price
      const proposalPrice = this.convertCurrencyToNumber(item.quoted.proposalPrice)

      const perc = (((proposalPrice * 100) / quotedPrice) - 100).toFixed()
      const total = proposalPrice * quantity * factor || 0

      const lowerValue = DefineLowestMaxPrice(item.quoted.cmedPrice, item.itemInfo.estimatedPrice)
      const proposalIsHigherThanMaxprice = lowerValue < proposalPrice

      for (const id in this.list) {
        if (this.list[id].itemId === item.itemId) {
          this.list[id].quoted.proposalIsHigherThanMaxprice = proposalIsHigherThanMaxprice
          this.list[id].quoted.proposalTotalPrice = total
          this.list[id].quoted.proposalPerc = perc
        }
      }
    },
    proposalRefreshTotalPrice (key, item) {
      if (key.keyCode === 9 || key.keyCode === 16) {
        return
      }

      const quantity = (item.itemInfo && item.itemInfo.quantity) || 0
      const factor = (item.itemInfo && item.itemInfo.factor) || 0

      const quotedPrice = item.quoted.price
      const proposalPerc = this.convertCurrencyToNumber(item.quoted.proposalPerc)

      const proposalPrice = (((proposalPerc + 100) * quotedPrice) / 100).toFixed(this.decimalPrecision)
      const total = proposalPrice * quantity * factor || 0

      const lowerValue = DefineLowestMaxPrice(item.quoted.cmedPrice, item.itemInfo.estimatedPrice)
      const proposalIsHigherThanMaxprice = proposalPrice > lowerValue

      const replaceReg = new RegExp(`(\\d{${this.decimalPrecision - 1}})(?=(\\d{3})+(?!\\d))`, 'g')
      for (const id in this.list) {
        if (this.list[id].itemId === item.itemId) {
          this.list[id].quoted.proposalIsHigherThanMaxprice = proposalIsHigherThanMaxprice
          this.list[id].quoted.proposalTotalPrice = total
          this.list[id].quoted.proposalPrice = proposalPrice
            .replace('.', ',')
            .replace(replaceReg, '$1.')
        }
      }
    },
    escapeProposalEdition (item) {
      this.list.map(i => {
        if (i.itemId === item.itemId) {
          i.quoted.proposalPrice = this.proposal.form.originalPrice
          i.quoted.proposalTotalPrice = this.proposal.form.originalTotalPrice
          i.quoted.proposalPerc = this.proposal.form.originalPerc
        }
      })
    },
    escapeMinimumEdition (item) {
      this.list.map(i => {
        if (i.itemId === item.itemId) {
          i.quoted.minimumPrice = this.minimum.form.originalPrice
          i.quoted.minimumTotalPrice = this.minimum.form.originalTotalPrice
          i.quoted.minimumPerc = this.minimum.form.originalPerc
        }
      })
    },
    minimumRefreshTotalPerc (key, item) {
      if (key.keyCode === 9 || key.keyCode === 16) {
        return
      }

      const quantity = (item.itemInfo && item.itemInfo.quantity) || 0
      const factor = (item.itemInfo && item.itemInfo.factor) || 0

      const quotedPrice = item.quoted.price
      const minimumPrice = this.convertCurrencyToNumber(item.quoted.minimumPrice)

      const perc = (((minimumPrice * 100) / quotedPrice) - 100).toFixed()
      const total = minimumPrice * quantity * factor || 0

      const lowerValue = DefineLowestMaxPrice(item.quoted.cmedPrice, item.itemInfo.estimatedPrice)
      const minimumIsHigherThanMaxprice = lowerValue < minimumPrice

      for (const id in this.list) {
        if (this.list[id].itemId === item.itemId) {
          this.list[id].quoted.minimumIsHigherThanMaxprice = minimumIsHigherThanMaxprice
          this.list[id].quoted.minimumTotalPrice = total
          this.list[id].quoted.minimumPerc = perc
          break
        }
      }
    },
    minimumRefreshTotalPrice (key, item) {
      if (key.keyCode === 9 || key.keyCode === 16) {
        return
      }

      const quantity = (item.itemInfo && item.itemInfo.quantity) || 0
      const factor = (item.itemInfo && item.itemInfo.factor) || 0

      const quotedPrice = item.quoted.price
      const minimumPerc = this.convertCurrencyToNumber(item.quoted.minimumPerc)

      const minimumPrice = (((minimumPerc + 100) * quotedPrice) / 100).toFixed(this.decimalPrecision)
      const total = minimumPrice * quantity * factor || 0

      const lowerValue = DefineLowestMaxPrice(item.quoted.cmedPrice, item.itemInfo.estimatedPrice)
      const minimumIsHigherThanMaxprice = minimumPrice > lowerValue

      const replaceReg = new RegExp(`(\\d{${this.decimalPrecision - 1}})(?=(\\d{3})+(?!\\d))`, 'g')
      for (const id in this.list) {
        if (this.list[id].itemId === item.itemId) {
          this.list[id].quoted.minimumIsHigherThanMaxprice = minimumIsHigherThanMaxprice
          this.list[id].quoted.minimumTotalPrice = total
          this.list[id].quoted.minimumPrice = minimumPrice
            .replace('.', ',')
            .replace(replaceReg, '$1.')
          break
        }
      }
    },
    minimumSetFocus (item) {
      this.minimum.form.originalPrice = item.quoted.minimumPrice
      this.minimum.form.originalTotalPrice = item.quoted.minimumTotalPrice
      this.minimum.form.originalPerc = item.quoted.minimumPerc
    },
    async minimumLostFocus (item) {
      let haveMinimum = true
      if (!item.quoted.minimumPrice) {
        haveMinimum = false
      } else {
        haveMinimum = item.quoted.minimumPrice &&
          item.quoted.minimumPrice.toString().trim().length > 0 &&
          this.convertCurrencyToNumber(item.quoted.minimumPrice) > 0
      }
      const newMinimumInfo = {
        haveMinimum,
        minimumPrice: haveMinimum ? this.convertCurrencyToNumber(item.quoted.minimumPrice) : '',
        minimumTotalPrice: haveMinimum ? item.quoted.minimumTotalPrice : '',
        minimumPerc: haveMinimum ? item.quoted.minimumPerc : '',
        proposalPrice: item.quoted.haveProposal ? this.convertCurrencyToNumber(item.quoted.proposalPrice) : ''
      }

      const payload = {
        quote: item.itemId,
        minimumPrice: newMinimumInfo.minimumPrice
      }
      await this.$store.dispatch('ItemPricing/SAVE_SALE_MINIMUM', payload)

      this.$store.commit('ItemPricing/SET_ITEM', {
        itemId: item.itemId,
        info: {
          quoted: {
            ...item.quoted,
            ...newMinimumInfo
          }
        }
      })
    },
    convertCurrencyToNumber (v) {
      return v && Number(v
        .toString()
        .replace('.', '')
        .replace(',', '.'))
    },
    doQuoteAgain (item) {
      const payloadItem = JSON.parse(JSON.stringify(item))
      const proposalMargin = this.$store.getters['ItemPricing/PROPOSAL_MARGIN']
      const decimalPrecision = this.$store.getters['ItemPricing/DECIMAL_PRECISION']
      const calc = (item.quoted.price * ((proposalMargin / 100) + 1)).toFixed(decimalPrecision)

      payloadItem.quoted.haveProposal = true
      payloadItem.quoted.proposalPrice = calc.toString().replace('.', ',')
      payloadItem.quoted.proposalTotalPrice = calc * payloadItem.itemInfo.quantity
      payloadItem.quoted.proposalPerc = proposalMargin.toString().replace('.', ',')

      payloadItem.quoted.haveMinimum = true
      payloadItem.quoted.minimumPrice = payloadItem.quoted.proposalPrice
      payloadItem.quoted.minimumTotalPrice = payloadItem.quoted.proposalTotalPrice
      payloadItem.quoted.minimumPerc = payloadItem.quoted.proposalPerc

      this.proposalLostFocus(payloadItem)
      this.minimumLostFocus(payloadItem)
    },
    editAssociationItem (itemInfo) {
      this.editAssociation.info = itemInfo
      this.$refs.rspEditCost.showPanel()
    },
    openHistoryOfItemPanel (itemInfo) {
      this.editHistoryItem.info = itemInfo
      this.$refs.rspHistoryItem.showPanel()
    },
    finishAssociationItem () {
      this.editAssociation.info = null
      this.$refs.rspEditCost.closePanel()
    },
    cancelAssociateEdition () {
      this.editAssociation.info = null
    },
    finishHistoryItem () {
      this.editHistoryItem.info = null
      this.$refs.rspHistoryItem.closePanel()
    },
    dynamicSetFocus (columnHeader, item) {
      this.dynamicColumn.form.originalValue = item.dynamicColumns[columnHeader.columnId].value
      this.dynamicColumn.form.columnId = item.dynamicColumns[columnHeader.columnId].columnId
    },
    escapeDynamicEdition (columnHeader, item) {
      item.dynamicColumns[columnHeader.columnId].value = this.dynamicColumn.form.originalValue
    },
    dynamicUnitEntered (key, columnHeader, item) {
      const inputValue = this.convertCurrencyToNumber(key.target.value)
      if (isNaN(inputValue)) {
        this.$toasted.error('Deve ser informado um número válido')
        return
      }

      const quotedPrice = item.quoted.price
      if (!quotedPrice) {
        this.$toasted.error('Esse item não foi escolhido')
        return
      }

      const perc = ((inputValue * 100) / quotedPrice) - 100
      const arrColumns = Object.keys(item.dynamicColumns)
      const columnIndex = arrColumns.indexOf(columnHeader.columnId)
      const columnTotal = arrColumns[columnIndex + 1]
      const columnPerc = arrColumns[columnIndex + 2]

      item.dynamicColumns[columnPerc].value = CurrencyBR(perc, '0', 0)
      this.dynamicCalcTotal(item, inputValue, columnTotal)
    },
    dynamicPercEntered (key, columnHeader, item) {
      const inputPerc = this.convertCurrencyToNumber(key.target.value)
      if (isNaN(key.key)) {
        return
      }
      if (isNaN(inputPerc)) {
        this.$toasted.error('Deve ser informado um número válido')
        return
      }

      const quotedPrice = item.quoted.price
      if (!quotedPrice) {
        this.$toasted.error('Esse item não foi escolhido')
        return
      }

      const perc = quotedPrice * ((inputPerc / 100) + 1)
      const arrColumns = Object.keys(item.dynamicColumns)
      const columnIndex = arrColumns.indexOf(columnHeader.columnId)
      const columnTotal = arrColumns[columnIndex - 1]
      const columnUnit = arrColumns[columnIndex - 2]
      if (isNaN(perc)) {
        item.dynamicColumns[columnUnit].value = 0
        item.dynamicColumns[columnTotal].value = 0
        return
      }

      const currencyPerc = perc.toFixed(4)
      item.dynamicColumns[columnUnit].value = CurrencyBR(currencyPerc, '0,00', 4)
      this.dynamicCalcTotal(item, currencyPerc, columnTotal)
    },
    dynamicCalcTotal (item, inputValue, columnTotal) {
      const quantity = (item.itemInfo && item.itemInfo.quantity) || 0
      const total = inputValue * quantity
      item.dynamicColumns[columnTotal].value = total
    },
    async dynamicLostFocus (columnHeader, item) {
      if (this.dynamicColumn.form.originalValue === item.dynamicColumns[columnHeader.columnId].value) {
        return
      }

      try {
        let columnValue = null

        switch (columnHeader.columnType) {
          case 'unit':
            columnValue = this.convertCurrencyToNumber(item.dynamicColumns[columnHeader.columnId].value)
            break
          case 'perc':
            columnValue = this.convertCurrencyToNumber(item.dynamicColumns[columnHeader.columnId].value)
            break
          case 'lab':
            columnValue = item.dynamicColumns[columnHeader.columnId].value
            break
          default:
            columnValue = item.dynamicColumns[columnHeader.columnId].value
            break
        }
        const dynamicColumnPayload = {
          itemId: item.itemId,
          rows: item.dynamicColumns
        }
        dynamicColumnPayload.rows[columnHeader.columnId].value = columnValue
        await this.$store.dispatch('ItemPricing/UPDATE_DYNAMIC_COLUMN', dynamicColumnPayload)

        // Update total when is unit
        if (columnHeader.columnType === 'unit') {
          const arrColumns = Object.keys(item.dynamicColumns)
          const columnIndex = arrColumns.indexOf(columnHeader.columnId)
          const columnTotal = arrColumns[columnIndex + 1]
          const columnPerc = arrColumns[columnIndex + 2]

          const quantity = (item.itemInfo && item.itemInfo.quantity) || 0
          const total = columnValue * quantity
          const perc = ((columnValue * 100) / item.quoted.price) - 100
          this.$store.commit('ItemPricing/SET_DYNAMIC_UNIT', {
            itemId: item.itemId,
            dynamicColumnId: columnHeader.columnId,
            value: columnValue,
            columnTotal,
            total,
            columnPerc,
            perc
          })
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/item-pricing/components/list-items/ListItems.vue